import { render, staticRenderFns } from "./RestrictionStats.vue?vue&type=template&id=216d138a&scoped=true&"
import script from "./RestrictionStats.vue?vue&type=script&lang=js&"
export * from "./RestrictionStats.vue?vue&type=script&lang=js&"
import style0 from "./RestrictionStats.vue?vue&type=style&index=0&id=216d138a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d138a",
  null
  
)

export default component.exports